import { RootState } from '../store'
import { LicenseFeature } from '../../types/license'

export const selectLicense = (state: RootState) => state.license.license
export const selectLicenseLoading = (state: RootState) => state.license.loading
export const selectLicenseError = (state: RootState) => state.license.error
export const selectLicenseInitialized = (state: RootState) => state.license.initialized
export const selectLicensePlan = (state: RootState) => state.license.license?.planKey ?? null
export const selectLicenseFeatures = (state: RootState): LicenseFeature[] =>
  state.license.license?.features ?? []
export const selectLicenseValidFrom = (state: RootState) => state.license.license?.validFrom ?? null
export const selectLicenseValidTo = (state: RootState) => state.license.license?.validTo ?? null
export const selectLicenseSeatLimit = (state: RootState) => state.license.license?.seatLimit ?? 0
export const selectLicenseActive = (state: RootState) => state.license.license?.active ?? true
export const selectLicenseIsOwner = (state: RootState) =>
  state.license.license?.isOwner === true

export const selectLicensePlans = (state: RootState) => state.license.plans
export const selectLicensePlansLoading = (state: RootState) => state.license.plansLoading
export const selectLicensePlansError = (state: RootState) => state.license.plansError
export const selectLicenseChanging = (state: RootState) => state.license.changing
export const selectLicenseChangeError = (state: RootState) => state.license.changeError
